import { setGetBonusCodeByIdAction } from '../action';
import { getBonusCodeByid } from '../api/getBonusCodeByid';

export const setGetBonusCodeById = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getBonusCodeByid(params);
            dispatch(setGetBonusCodeByIdAction(data.data))

            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}